import { schedule_types_ids } from "features/Listings/constants/Listings.constants";
import { useFetchCustomCodeOfferings } from "./useFetchCustomCodeOfferings";
import { custom_code_metadata_keys } from "../Codes.config";

export const useFetchCustomCodeRCOfferings = ({ fetch, initialData = {} }) => {
  return useFetchCustomCodeOfferings({
    fetch,
    initialData,
    listingType: schedule_types_ids.content,
    metadataKey: custom_code_metadata_keys.recorded_content_pages,
  });
};
